import React from 'react';
import { CURRENT_VERSION, CHANGELOG } from './version';
import { CheckIcon } from './icons'; // Using an existing icon for style consistency

const VersionModal: React.FC<{ isOpen: boolean; onClose: () => void }> = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-70 z-50 flex justify-center items-center p-4"
            onClick={onClose}
            role="dialog"
            aria-modal="true"
            aria-labelledby="version-modal-title"
        >
            <div
                className="bg-light-surface dark:bg-surface rounded-lg shadow-xl w-full max-w-2xl border border-light-border dark:border-border flex flex-col max-h-[90vh]"
                onClick={e => e.stopPropagation()}
            >
                <div className="flex justify-between items-center p-6 border-b border-light-border dark:border-border flex-shrink-0">
                    <h2 id="version-modal-title" className="text-2xl font-bold text-light-text-primary dark:text-text-primary">
                        Historial de Versiones
                    </h2>
                    <button
                        onClick={onClose}
                        className="text-light-text-secondary dark:text-text-secondary hover:text-light-text-primary dark:hover:text-text-primary transition-colors"
                        aria-label="Cerrar modal"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                        </svg>
                    </button>
                </div>
                <div className="p-6 sm:p-8 overflow-y-auto">
                    <div className="space-y-6">
                        {CHANGELOG.map((versionInfo) => (
                            <div key={versionInfo.version}>
                                <div className="flex items-center gap-3">
                                    <h3 className="text-xl font-semibold text-light-text-primary dark:text-text-primary">
                                        Versión {versionInfo.version}
                                    </h3>
                                    {versionInfo.version === CURRENT_VERSION && (
                                        <span className="px-2 py-0.5 text-xs font-medium bg-secondary/20 text-secondary rounded-full">
                                            Actual
                                        </span>
                                    )}
                                     <span className="text-sm text-light-text-secondary dark:text-text-secondary ml-auto">
                                        {versionInfo.date}
                                    </span>
                                </div>
                                <ul className="mt-3 list-none space-y-2">
                                    {versionInfo.changes.map((change, index) => (
                                        <li key={index} className="flex items-start gap-3">
                                            <CheckIcon className="w-5 h-5 text-secondary flex-shrink-0 mt-0.5" />
                                            <span className="text-light-text-secondary dark:text-text-secondary">{change}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
                 <div className="p-4 bg-gray-100 dark:bg-gray-800 border-t border-light-border dark:border-border flex-shrink-0 text-right rounded-b-lg">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 rounded-md bg-primary hover:bg-blue-600 text-white font-semibold transition-colors"
                    >
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default VersionModal;
